import { db } from '../../firebase';
import { PriceTier } from '../types/priceTier';
import { doc, getDoc } from 'firebase/firestore';
import { parseContent } from '../utils';
import { parsePriceTiers } from './parser';

export const getAllPriceTiers = async (): Promise<PriceTier[]> => {
  try {
    const _query = await getDoc(doc(db, 'settings', 'appPriceTiers'));
    if (!_query.exists()) {
      console.log('No such document!');
      return [];
    }
    return await parsePriceTiers(parseContent(_query));
  } catch (error) {
    console.log(`[PRICE TIERS] Error at getAllPriceTiers`, error);
    return [];
  }
};
